import React from "react";
import {CityListDental} from "../CityList/CityListDental";
import {connect} from "react-redux";
import {openDialogAction} from "../../../comun/DialogManager/DialogManagerAction";
import {getCities} from "../CityAction";
import {CityFilters} from "../../City/CityFilter/CityFilter";



export let ManageCityDentalFilter = ({user, cities, ...props}) => {
    
    return (
        <CityListDental title="Gestionar Ciudades"  action={getCities} />
    )
}


const mapDispatchToProps = dispatch => {
    return {
        onDialogOpen: data => {
            dispatch(openDialogAction(data));
        },
    }
}


const mapStateToProps = (state) => {
    return {cities: state.cities};
}
ManageCityDentalFilter = connect(mapStateToProps, mapDispatchToProps)(ManageCityDentalFilter);


